import React, { useCallback, useMemo } from 'react';
import helpers from '@starflow/app/helpers';

import leftAlign from './assets/left-align.svg';
import leftRightCenterAlign from './assets/left-right-center-align.svg';
import rightAlign from './assets/right-align.svg';
import topAlign from './assets/top-align.svg';
import topBottomCenterAlign from './assets/top-bottom-center-align.svg';
import bottomAlign from './assets/bottom-align.svg';
import { getProjectState, useProjectState } from '@starflow/app/store';

// todos fqy 这里做完旋转后要回归
export const AlignTool = () => {
  const selection = useProjectState('selection');
  const disabled = selection.length === 1;
  return (
    <div className={`flex justify-items-center items-center ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}>
      <button
        className={`w-5 h-5 flex justify-center items-center rounded-sm mr-3 hover:bg-[#F4F6F8] ${
          disabled ? 'pointer-events-none' : ''
        }`}
        onClick={() => {
          const range = helpers.utils.getSelectionRange();
          selection.forEach((id) => {
            helpers.canvas.updateElement(id, {
              x: range.minX,
            });
          });
        }}
      >
        <img src={leftAlign} alt="" />
      </button>
      <button
        className={`w-5 h-5 flex justify-center items-center rounded-sm mr-3 hover:bg-[#F4F6F8] ${
          disabled ? 'pointer-events-none' : ''
        }`}
        onClick={() => {
          const range = helpers.utils.getSelectionRange();
          const centerX = (range.maxX + range.minX) / 2;
          const { elements } = getProjectState();
          selection.forEach((id) => {
            const aimElement = elements.find((item) => item.id === id);
            helpers.canvas.updateElement(id, {
              x: centerX - (aimElement.width * aimElement.scaleX) / 2,
            });
          });
        }}
      >
        <img src={leftRightCenterAlign} alt="" />
      </button>
      <button
        className={`w-5 h-5 flex justify-center items-center rounded-sm mr-3 hover:bg-[#F4F6F8] ${
          disabled ? 'pointer-events-none' : ''
        }`}
        onClick={() => {
          const range = helpers.utils.getSelectionRange();
          const { elements } = getProjectState();
          selection.forEach((id) => {
            const aimElement = elements.find((item) => item.id === id);
            const newX = range.maxX - aimElement.width * aimElement.scaleX;
            helpers.canvas.updateElement(id, {
              x: newX,
            });
          });
        }}
      >
        <img src={rightAlign} alt="" />
      </button>
      <button
        className={`w-5 h-5 flex justify-center items-center rounded-sm mr-3 hover:bg-[#F4F6F8] ${
          disabled ? 'pointer-events-none' : ''
        }`}
        onClick={() => {
          const range = helpers.utils.getSelectionRange();
          selection.forEach((id) => {
            helpers.canvas.updateElement(id, {
              y: range.minY,
            });
          });
        }}
      >
        <img src={topAlign} alt="" />
      </button>
      <button
        className={`w-5 h-5 flex justify-center items-center rounded-sm mr-3 hover:bg-[#F4F6F8] ${
          disabled ? 'pointer-events-none' : ''
        }`}
        onClick={() => {
          const range = helpers.utils.getSelectionRange();
          const { elements } = getProjectState();
          const centerY = (range.maxY + range.minY) / 2;
          selection.forEach((id) => {
            const aimElement = elements.find((item) => item.id === id);
            helpers.canvas.updateElement(id, {
              y: centerY - (aimElement.height * aimElement.scaleY) / 2,
            });
          });
        }}
      >
        <img src={topBottomCenterAlign} alt="" />
      </button>
      <button
        className={`w-5 h-5 flex justify-center items-center rounded-sm mr-3 hover:bg-[#F4F6F8] ${
          disabled ? 'pointer-events-none' : ''
        }`}
        onClick={() => {
          const range = helpers.utils.getSelectionRange();
          const { elements } = getProjectState();
          selection.forEach((id) => {
            const aimElement = elements.find((item) => item.id === id);
            helpers.canvas.updateElement(id, {
              y: range.maxY - aimElement.height * aimElement.scaleY,
            });
          });
        }}
      >
        <img src={bottomAlign} alt="" />
      </button>
    </div>
  );
};
